export const MENTION_NODE_NAME = 'mention';

export const MENTION_TYPE_ATTR = 'data-mention-type';

export enum MentionTypes {
  User = 'USER',
  Content = 'Content',
  Event = 'Event',
}

export interface MentionNodeAttrs {
  name: string;
  href?: string;
  id: string;
  type: MentionTypes;
}
